import userDuck from '@/ducks/userDuck.js';

export default function saveRecentInventory(id) {
    return (dispatch) => {
        dispatch(userDuck.creators.saveRecentInventory({ id }));
    };
}
